import $foreign from "./foreign.cjs";
var unsafeDelete = $foreign.unsafeDelete;
var unsafeGet = $foreign.unsafeGet;
var unsafeHas = $foreign.unsafeHas;
var unsafeSet = $foreign.unsafeSet;
export { unsafeDelete, unsafeGet, unsafeHas, unsafeSet };
